import { render } from "./CorrectThreeView.vue?vue&type=template&id=49acbcaa&ts=true"
import script from "./CorrectThreeView.vue?vue&type=script&lang=ts"
export * from "./CorrectThreeView.vue?vue&type=script&lang=ts"

import "./CorrectThreeView.vue?vue&type=style&index=0&id=49acbcaa&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__